module.exports = __webpack_public_path__ + "media/images/loading-ee4bc3452e905326fc762ae05a58993a.gif";